import React from 'react';
import { ProjectAmount, ProjectAmountTitle } from './ProjectsSupported.styled';

export const ProjectsSupportedSubTitle = ({ children, title, amount }) => {

  return (
    <div className='d-flex justify-content-start justify-content-lg-center pd-0-50 amount-component'>
      { children}
      <div className='pl-2'>
        <ProjectAmountTitle>{title}</ProjectAmountTitle>
        <ProjectAmount>
          {amount}
        </ProjectAmount>
      </div>
    </div>
  );
};
